import {Action, createReducer, on} from '@ngrx/store';
import {AppNgrx} from '~model/ngrx/app-ngrx';
import {appClear, setMenuOpened, setPalette, setLogo} from '~feature/feature-app/feature-app.actions';

export const initialState: AppNgrx = {menuOpened: false, palette: ''};

const reducer = createReducer(
  initialState,
  on(setMenuOpened, (state, {menuOpened}) => ({...state, menuOpened})),
  on(setPalette, (state, {palette}) => ({...state, palette})),
  on(setLogo, (state, {logo}) => ({...state, logo})),
  on(appClear, () => (initialState))
);

export const FeatureAppReducer = (state: AppNgrx | undefined, action: Action) => reducer(state, action);
